import script from "./SelectBranch.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBranch.vue?vue&type=script&setup=true&lang=js"

import "./SelectBranch.vue?vue&type=style&index=0&id=799ea81a&scoped=true&lang=css"

import exportComponent from "/var/www/html/product/petcare_admin_panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799ea81a"]])

export default __exports__